module.exports = __webpack_public_path__ + "static/media/D11.497d5f12.png";